import React from "react";
import { useResources } from "../../utility/use-resources";

const amperoctoplus = (s) => {
  s = s.replace(/&/g, "%26");
  s = s.replace(/#/g, "%23");
  s = s.replace(/\+/g, "%2B");
  s = s.replace(/@/g, "%40");
  s = s.replace(/:/g, "%3A");
  return s;
};

const defaultResources = [
  { name: "facebook", url: "https://www.facebook.com/vicoustic" },
  { url: "https://twitter.com/Vicoustic", name: "twitter" },
  {
    name: "linkedin",
    url:
      "https://www.linkedin.com/company/vicoustic---innovative-acoustic-solutions",
  },
  { url: "https://www.instagram.com/vicoustic/", name: "instagram" },
];

const classNameForType = {
  facebook: "fab fa-facebook-f",
  twitter: "fab fa-twitter",
  linkedin: "fab fa-linkedin-in",
  instagram: "fab fa-instagram",
  youtube: "fab fa-youtube",
  pinterest: "fab fa-pinterest",
};

const Socials = (props) => {
  const { share } = props;

  const [r] = useResources("general");
  const resources = r("socials") || defaultResources;

  if (!share) {
    return (
      <ul className="nav-socials">
        {resources.map((item) => (
          <li>
            <a
              tabIndex={props.tabIndex ? props.tabIndex : ""}
              href={item.url}
              target="_blank"
            >
              <i className={classNameForType[item.name]}></i>
            </a>
          </li>
        ))}
      </ul>
    );
  }

  const currentUrl = amperoctoplus(encodeURI(window.location.href));
  const facebookURL = props.share
    ? "https://www.facebook.com/sharer/sharer.php?u=" + currentUrl
    : "https://www.facebook.com/vicoustic";
  const twitterURL = props.share
    ? "https://twitter.com/home?status=" + currentUrl
    : "https://twitter.com/Vicoustic";
  const linkedinURL = props.share
    ? "https://www.linkedin.com/shareArticle?mini=true&url=" +
      currentUrl +
      "&title=" +
      currentUrl
    : "https://www.linkedin.com/company/vicoustic---innovative-acoustic-solutions";

  const event = (e) => {
    e.preventDefault();
    const screenHeight = window.screen.height;
    const screenWidth = window.screen.width;
    const left = Math.round(screenWidth / 2 - 275);
    const top = screenHeight > 420 ? Math.round(screenHeight / 2 - 210) : 0;
    window.open(
      e.currentTarget.href,
      "targetWindow",
      "toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=550, height=420, left=" +
        left +
        ", top=" +
        top
    );
    return false;
  };

  return (
    <ul className="nav-socials">
      <li>
        <a
          tabIndex={props.tabIndex ? props.tabIndex : ""}
          onClick={event}
          href={facebookURL}
          target="_blank"
        >
          <i className="fab fa-facebook-f"></i>
        </a>
      </li>
      <li>
        <a
          tabIndex={props.tabIndex ? props.tabIndex : ""}
          onClick={event}
          href={twitterURL}
          target="_blank"
        >
          <i className="fab fa-twitter"></i>
        </a>
      </li>
      <li>
        <a
          tabIndex={props.tabIndex ? props.tabIndex : ""}
          onClick={event}
          href={linkedinURL}
          target="_blank"
        >
          <i className="fab fa-linkedin-in"></i>
        </a>
      </li>
    </ul>
  );
};

export default Socials;
